import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import {
  AnalyzerToken,
  ElasticsearchAnalyzerIndexTarget,
  ElasticsearchAnalyzerType,
  SearchService,
} from '@libs/shared/api';
import { AnalyzeTokenRendererComponent } from '@libs/shared/ui/elasticsearch-term-analyzer/analyze-token-renderer.component';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'app-elasticsearch-analyze-token-inline-result',
  standalone: true,
  imports: [CommonModule, AnalyzeTokenRendererComponent],
  template: `
    <app-analyze-token-renderer [tokens]="analyzeTokens$ | async" />
    <ng-template #noResults />
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ElasticsearchAnalyzeTokenInlineResultComponent
  implements OnChanges
{
  @Input() keyword: string;
  @Input() indexTarget: ElasticsearchAnalyzerIndexTarget = 'General';
  @Input() textSize: 'small' | 'medium' | 'large' = 'medium';
  @Input() lineBreak = false;
  @Input() analyzer: ElasticsearchAnalyzerType =
    ElasticsearchAnalyzerType.KoreanAnalyzerSearch;
  analyzeTokens$: Observable<AnalyzerToken[]>;

  constructor(private _searchService: SearchService) {}

  onFetchAnalyzeTokens(keyword: string) {
    if (keyword) {
      this.analyzeTokens$ = this._searchService
        .analyzeTerm(keyword, this.indexTarget, this.analyzer)
        .pipe();
    } else {
      this.analyzeTokens$ = of([]);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.keyword.currentValue !== changes.keyword.previousValue) {
      this.onFetchAnalyzeTokens(this.keyword);
    }
  }
}
